import React from "react";
import { Button, Popover, Tag, Typography } from "antd";
import { IBettingWebsiteFeature } from "../../../../types/BettingWebsite.Feature";
import { Link } from "react-router-dom";
import { CheckCircleFilled, EditOutlined } from "@ant-design/icons";

const { Text } = Typography;

type Props = {
  features: IBettingWebsiteFeature[];
  currentLang?: "En" | "Ar" | "Fr";
  id: string;
  page: number;
  pageSize: number;
};

export const FeaturesPopover: React.FC<Props> = ({
  features,
  currentLang = "En",
  id,
  page,
  pageSize,
}) => {
  const content = (
    <div className="space-y-2 max-w-xs">
      {features.map((feature) => (
        <div key={feature.id} className="flex items-center">
          <Text>
            <CheckCircleFilled className="text-emerald-500" />{" "}
            {feature.Feature[currentLang]}
          </Text>
        </div>
      ))}
    </div>
  );

  return (
    <Popover
      title={
        <div className="flex flex-row w-full justify-between border-b pb-0.5">
          <span>Features</span>
          <Link
            to={`/betting-websites/edit-features/${id}?page=${
              page + 1
            }&pageSize=${pageSize}`}
          >
            <Button size="small" type="link" icon={<EditOutlined />} />
          </Link>
        </div>
      }
      content={content}
      trigger="hover"
      placement="right"
    >
      <Tag color="geekblue" className="cursor-pointer">
        Show Features
      </Tag>
    </Popover>
  );
};
